import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getKnowledgeAuthList, getKnowledgeCatalogueList } from '@/views/manageCenter/api';
import { delOrganizeWorkItem, getKnowCategoryResponderList, getOrganizeWorkDetail } from '@/api/directoryManagement';
import { createFeedback, getArtilleryRadar, createEvaluationFeedback } from '@/views/downLoadCenter/api/api';
import FeedbackDialog from '@/views/downLoadCenter/feedbackDialog.vue';
import MyFeedbackList from '@/views/downLoadCenter/myFeedbackList.vue';
export default {
  name: 'functionalDivisionList',
  components: {
    FeedbackDialog: FeedbackDialog,
    MyFeedbackList: MyFeedbackList
  },
  data: function data() {
    return {
      form: {
        keyword: '',
        category_id: '',
        organize_id: '',
        first_responder_id: '',
        second_responder_id: '',
        page: 1,
        page_size: 50
      },
      dataList: [],
      pages: {},
      // 人员下拉远程搜索：按下拉字段隔离选项，已选项缓存记录 id→选项（换关键字后已选标签不退化）
      personOptions: {},
      personOptionCache: {},
      personLoading: false,
      options: [],
      category: [],
      dialogTitle: '',
      dialogVisible: false,
      addForm: {
        feedback_content: ''
      },
      type: 'add',
      subMitLoading: false,
      drawer: false,
      myFeedbackListVisible: false
    };
  },
  created: function created() {
    // 初始预载人员下拉默认选项（空关键词返回默认列表）
    this.searchFirstResponder('');
    this.searchSecondResponder('');
    this.getOrganizeList();
    this.getCategoryList();
    this.getDate();
  },
  methods: {
    getDate: function getDate() {
      var _this = this;
      var params = _objectSpread({}, this.form);
      if (this.$refs.organize) {
        params.organize_id = this.$refs.organize.getCheckedNodes(false, true).map(function (res) {
          return res.value;
        });
      }
      getArtilleryRadar(params).then(function (res) {
        _this.dataList = res.data.list;
        _this.pages = res.pages;
      });
    },
    handleFeedback: function handleFeedback() {
      var event = this.$refs.feedbackDialog;
      event.dialogVisible = true;
    },
    // 评价明细
    evaluateDetails: function evaluateDetails(row) {
      var _this2 = this;
      this.$confirm('此内容是我想要的', '内容有效反馈', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        createEvaluationFeedback({
          item_id: row.id
        }).then(function (res) {
          _this2.getDate();
          _this2.$message({
            type: 'success',
            message: '操作成功!'
          });
        });
      });
    },
    getSearch: function getSearch() {
      this.form.page = 1;
      this.getDate();
    },
    sizeChange: function sizeChange(size) {
      this.form.page_size = size;
      this.getDate();
    },
    currentChange: function currentChange(current) {
      this.form.page = current;
      this.getDate();
    },
    getCategoryList: function getCategoryList() {
      var _this3 = this;
      getKnowCategoryResponderList().then(function (res) {
        _this3.category = res.data.tree;
      });
    },
    getOrganizeList: function getOrganizeList() {
      var _this4 = this;
      var params = {
        id: ''
      };
      getKnowledgeAuthList(params).then(function (res) {
        _this4.options = res.data.tree;
      });
    },
    // 人员下拉通用远程搜索：结果按字段存进 personOptions，已选项从缓存回填
    searchPerson: function searchPerson(keyword, field, valueGetter) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var kw, res, list, selected, picked;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              kw = (keyword || '').trim();
              _this5.personLoading = true;
              _context.p = 1;
              _context.n = 2;
              return getKnowledgeCatalogueList({
                keyword: kw,
                source: 1
              });
            case 2:
              res = _context.v;
              list = res.data || [];
              list.forEach(function (item) {
                _this5.personOptionCache[String(item.id)] = item;
              });
              // 结果并入已选项：换关键字会销毁旧 option，已选标签需继续有数据可查
              selected = valueGetter();
              if (!Array.isArray(selected)) {
                selected = selected === undefined || selected === null || selected === '' ? [] : [selected];
              }
              picked = selected.filter(function (id) {
                return !list.some(function (item) {
                  return String(item.id) === String(id);
                });
              }).map(function (id) {
                return _this5.personOptionCache[String(id)];
              }).filter(Boolean);
              _this5.$set(_this5.personOptions, field, picked.concat(list));
            case 3:
              _context.p = 3;
              _this5.personLoading = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1,, 3, 4]]);
      }))();
    },
    // 第一负责人（列表筛选）
    searchFirstResponder: function searchFirstResponder(keyword) {
      var _this6 = this;
      return this.searchPerson(keyword, 'firstResponder', function () {
        return _this6.form.first_responder_id;
      });
    },
    // 第二负责人（列表筛选）
    searchSecondResponder: function searchSecondResponder(keyword) {
      var _this7 = this;
      return this.searchPerson(keyword, 'secondResponder', function () {
        return _this7.form.second_responder_id;
      });
    }
  }
};